import { render, staticRenderFns } from "./VNotification.vue?vue&type=template&id=8b1c3960&scoped=true"
import script from "./VNotification.vue?vue&type=script&lang=ts"
export * from "./VNotification.vue?vue&type=script&lang=ts"
import style0 from "./VNotification.vue?vue&type=style&index=0&id=8b1c3960&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1c3960",
  null
  
)

export default component.exports